import React, { useId, useState } from 'react';

function Chevron() {
    return (
        <svg className="cc-collapsible__chevron" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
            <path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

// A titled box whose content opens and closes. With collapsible={false} it is a plain titled
// block that is always open, so one component serves both the tabbed and the accordion layout.
function CollapsibleSection({ title, collapsible = true, defaultOpen = false, className = '', children }) {
    const contentId = useId();
    const [isOpenState, setIsOpenState] = useState(defaultOpen);
    const isOpen = collapsible ? isOpenState : true;
    const rootClass = ['cc-collapsible', isOpen ? 'is-open' : '', collapsible ? 'is-collapsible' : '', className]
        .filter(Boolean)
        .join(' ');

    return (
        <section className={rootClass}>
            <h3 className="cc-collapsible__heading">
                {collapsible ? (
                    <button
                        type="button"
                        className="cc-collapsible__button"
                        aria-expanded={isOpen}
                        aria-controls={contentId}
                        onClick={() => setIsOpenState((current) => !current)}
                    >
                        <Chevron />
                        {title}
                    </button>
                ) : title}
            </h3>
            <div id={contentId} className="cc-collapsible__panel">
                <div className="cc-collapsible__inner">{children}</div>
            </div>
        </section>
    );
}

export default CollapsibleSection;
